import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

import { IonButton, IonCol, IonGrid, IonIcon, IonRow, modalController } from "@ionic/vue";
import { reactive, ref } from "vue";
import { route } from "@/router";
import { useForm } from "vee-validate";
import { t } from "@/plugins/vue-i18n";

import ModalControllerBase from "@/components/modal/modalControllerModals/ModalControllerBase.vue";
import CustomHeader from "@/components/basePageElements/CustomHeader.vue";
import InputSimple from "@/components/input/InputSimple.vue";
import ButtonFix from "@/components/button/ButtonFix.vue";
import SelectSimple from "@/components/selects/SelectSimple.vue";

import { useListStore } from "@/stores/lists";
import { useSupplierStore } from "@/stores/suppliers";

import { replaceToast } from "@/functions/baseToast";

import { INPUT_MODE, INPUT_TYPE } from "@/types/enum/ionicEnum";
import { CustomProduct } from "@/types/supplier";

import { chevronBack } from "ionicons/icons";
import { isApp } from "@/functions/enviroment";
import { GetListItemsParams } from "@/types/list";
import { SORT_METHOD } from "@/types/enum/propEnum";
import { CreateProductProps } from "@/types/props";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateProduct',
  props: {
    supplierId: {},
    listId: {},
    edit: { type: Boolean },
    listItemId: {},
    product: {}
  },
  setup(__props: any) {

const props = __props

const listStore = useListStore()
const supplierStore = useSupplierStore()

const listId = ref<string>(props.listId)
const locationId = route.value.params.locationId as string

const newProduct = reactive<CustomProduct>(props.product ? {
    name: props.product?.name,
    eancode: props.product?.eanCode,
    packaging: props.product?.packaging
} : {
    name: '',
    quantity: 0
})

const { meta, validate } = useForm({
    validationSchema: {
        name: 'required',
        targetStock: '',
        quantity: props.edit ? 'numeric' : 'required|numeric',
        listId: !props.listId ? 'required' : undefined
    }
})

const addProduct = async (): Promise<void> => {
    if (props.edit) {
        if (!props.listItemId) return
        await listStore.editCustomProduct({
            locationId,
            listId: listId.value,
            listItemId: props.listItemId,
            body: newProduct
        })
        window.dispatchEvent(new Event('reload-list'))
        while ((await modalController.getTop())) {
            await modalController.dismiss()
        }
        return
    }
    if (!(await validate()).valid) return

    const response = await listStore.addCustomProduct(locationId, listId.value, newProduct)

    if (!response) return

    // supplierStore.itemsLoaded = false
    await supplierStore.getCatalog({
        locationId: locationId,
        supplierId: props.supplierId,
    })
    if (!isApp() && props.listId) await supplierStore.getCatalog({
        locationId: locationId,
        supplierId: props.supplierId,
        includeList: listId.value
    })
    window.dispatchEvent(new Event('force-reload-catalog'))
    // supplierStore.isLoaded.catalog = true
    replaceToast({
        message: t('messages.dashboard.catalog.createdCustomProduct'),
        id: 'added-product'
    })

    if (!isApp() && props.listId) {
        listStore.isLoaded.listItems = false
        await listStore.getListItems(new GetListItemsParams({
            locationId,
            listId: props.listId,
            searchKey: listStore.searchQuery !== '' ? listStore.searchQuery : undefined,
            category: listStore.listFilter.category !== '' ? listStore.listFilter.category : undefined,
            tags: listStore.activeFiltersIds.length !== 0 ? listStore.activeFiltersIds.join(',') : undefined,
            withQuantity: listStore.listFilter.withQuantity,
            // sortField: (listStore.sortDesc) ? 'name' : undefined,
            sortDesc: (listStore.listFilter.sortDirection === SORT_METHOD.ALPH_DESC)
        }))
        listStore.isLoaded.listItems = true
        window.dispatchEvent(new Event('force-reload-catalog'))
    }

    modalController.dismiss(undefined, 'add')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalControllerBase, { contentClass: "light-light-background purple-purple-color" }, {
    header: _withCtx(() => [
      _createVNode(CustomHeader, {
        "back-button": "",
        title: _ctx.$t(__props.edit ? 'titleRoute.editProduct' : 'titleRoute.addProduct')
      }, {
        start: _withCtx(() => [
          _createVNode(_unref(IonButton), {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modalController).dismiss())),
            class: "purple-light-color"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), { icon: _unref(chevronBack) }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('button.back')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(IonGrid), { class: "max-content-width-tablet" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "fs-smaller purple-purple-color" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`placeholder.name`)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "center-x" }, {
                default: _withCtx(() => [
                  _createVNode(InputSimple, {
                    "input-class": "grey4-grey4-background",
                    placeholder: `${_ctx.$t('placeholder.name')}*`,
                    modelValue: newProduct.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newProduct.name) = $event)),
                    "validate-option": { name: 'name', label: _ctx.$t('label.name') }
                  }, null, 8, ["placeholder", "modelValue", "validate-option"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!__props.edit)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(IonRow), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), { class: "fs-smaller purple-purple-color" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`placeholder.quantity`)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonRow), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), { class: "center-x" }, {
                      default: _withCtx(() => [
                        _createVNode(InputSimple, {
                          "input-class": "grey4-grey4-background",
                          placeholder: `${_ctx.$t('placeholder.quantity')}*`,
                          type: _unref(INPUT_TYPE).NUMBER,
                          inputmode: _unref(INPUT_MODE).NUMERIC,
                          modelValue: newProduct.quantity,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newProduct.quantity) = $event)),
                          modelModifiers: { number: true },
                          "validate-option": { name: 'quantity', label: _ctx.$t('label.quantity') }
                        }, null, 8, ["placeholder", "type", "inputmode", "modelValue", "validate-option"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonRow), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), { class: "fs-smaller purple-purple-color" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`label.targetStock`)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonRow), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), { class: "center-x" }, {
                      default: _withCtx(() => [
                        _createVNode(InputSimple, {
                          "input-class": "grey4-grey4-background",
                          placeholder: `${_ctx.$t('label.targetStock')}`,
                          type: _unref(INPUT_TYPE).NUMBER,
                          inputmode: _unref(INPUT_MODE).NUMERIC,
                          modelValue: newProduct.targetStock,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newProduct.targetStock) = $event)),
                          modelModifiers: { number: true },
                          "validate-option": { name: 'targetStock', label: _ctx.$t('label.targetStock') }
                        }, null, 8, ["placeholder", "type", "inputmode", "modelValue", "validate-option"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "fs-smaller purple-purple-color" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`placeholder.packaging`)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "center-x" }, {
                default: _withCtx(() => [
                  _createVNode(InputSimple, {
                    "input-class": "grey4-grey4-background",
                    placeholder: _ctx.$t('placeholder.packaging'),
                    modelValue: newProduct.packaging,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newProduct.packaging) = $event)),
                    "validate-option": { name: 'packaging', label: _ctx.$t('label.packaging') }
                  }, null, 8, ["placeholder", "modelValue", "validate-option"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "fs-smaller purple-purple-color" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`placeholder.eancode`)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "center-x" }, {
                default: _withCtx(() => [
                  _createVNode(InputSimple, {
                    "input-class": "grey4-grey4-background",
                    placeholder: _ctx.$t('placeholder.eancode'),
                    modelValue: newProduct.eancode,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newProduct.eancode) = $event)),
                    "validate-option": { name: 'eancode', label: _ctx.$t('label.eancode') }
                  }, null, 8, ["placeholder", "modelValue", "validate-option"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!props.listId)
            ? (_openBlock(), _createBlock(_unref(IonRow), { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), { class: "fs-smaller purple-purple-color" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(`label.list`)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!props.listId)
            ? (_openBlock(), _createBlock(_unref(IonRow), { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), { class: "center-x" }, {
                    default: _withCtx(() => [
                      _createVNode(SelectSimple, {
                        modelValue: listId.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((listId).value = $event)),
                        options: _unref(listStore).supplierLists(__props.supplierId),
                        "value-key": "id",
                        "text-key": "name",
                        "validate-option": { name: 'listId', label: _ctx.$t('label.list') }
                      }, null, 8, ["modelValue", "options", "validate-option"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonRow), { class: "mt-3" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "center-x" }, {
                default: _withCtx(() => [
                  _createVNode(ButtonFix, {
                    disabled: !_unref(meta).valid,
                    onClick: addProduct
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(__props.edit ? 'button.edit' : 'button.add')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})